import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function BrandStory() {
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className="section-reveal grid lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="w-full h-[500px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/7e7c5fa022d3a777f813ff5bbf83ed4d.jpg"
                alt="Willie Robinson - Founder, TECS Limo Service LLC"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Gold frame accent */}
            <div className="absolute -bottom-4 -right-4 w-28 h-28 border-2 border-gold/30 pointer-events-none"></div>
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-gold/10 pointer-events-none"></div>
            {/* Stat overlay */}
            <div className="absolute bottom-8 left-8 bg-neutral-950/95 border border-gold/25 px-6 py-4">
              <div className="text-gold font-display text-3xl font-bold">10+</div>
              <div className="text-white/55 text-xs tracking-widest uppercase mt-0.5">Years of Service</div>
            </div>
          </div>

          {/* Text side */}
          <div>
            <span className="text-gold text-xs tracking-widest uppercase font-semibold">Our Story</span>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-neutral-900 mt-3 mb-6 leading-tight">
              A Company Built on<br />
              <span className="relative inline-block">
                Reliability & Trust
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gold"></span>
              </span>
            </h2>

            <div className="space-y-4 text-neutral-600 leading-relaxed text-sm mt-8">
              <p>
                TECS Limo Service LLC was founded by <strong className="text-neutral-900">Willie Robinson</strong>, a former Charleston County Police Officer with years of law enforcement experience — including security work with three presidential campaigns. His background instilled a deep commitment to safety, punctuality, and professional service that defines every ride we provide.
              </p>
              <p>
                Our mission is simple: deliver safe, private, and dependable luxury transportation in Charleston, SC with a team that values your time, your comfort, and your trust. We serve locals, business travelers, tourists, and VIP clients who demand the very best in ground transportation.
              </p>
              <p>
                Every vehicle is meticulously maintained, every chauffeur is thoroughly trained, and every pickup is handled with the care and precision our clients expect. We are available 24 hours a day, 7 days a week, because your transportation needs don&apos;t follow a 9-to-5 schedule.
              </p>
            </div>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-4 mt-10 mb-10">
              {[
                { val: '10+', label: 'Years in Service' },
                { val: '5★', label: 'Google Rating' },
                { val: '24/7', label: 'Always Available' },
              ].map((s) => (
                <div key={s.label} className="border border-neutral-100 p-4 text-center">
                  <div className="text-gold font-display text-2xl font-bold">{s.val}</div>
                  <div className="text-neutral-500 text-xs mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="bg-neutral-900 hover:bg-gold transition-colors text-white hover:text-black font-bold px-8 py-4 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer">
                Book a Ride
              </a>
              <a href="tel:+18436422440" className="flex items-center gap-2 border-2 border-neutral-200 hover:border-gold text-neutral-700 hover:text-gold transition-colors font-semibold px-8 py-4 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm"></i></div>
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
